import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";

const useTransCode = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const trans_code = searchParams.get("trans_code");

  useEffect(() => {
    if (trans_code) {
      Cookies.set("trans_code", trans_code, { expires: 1 });
    }
  }, [trans_code]);

  return trans_code || Cookies.get("trans_code");
};

export default useTransCode;
